function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Energiebesparing-\\u20AC-dit-jaar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Energiebesparing-\\u20AC-dit-jaar",
  transform: "translate(1.000000, 1.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  stroke: "#485156"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.1664,12.2 L24.1664,1.4 C24.1646002,1.0070838 23.9708104,0.639868805 23.6474562,0.416645975 C23.324102,0.193423146 22.9120371,0.142395286 22.544,0.28 L9.344,7.112 C8.87757388,7.28789549 8.56818805,7.73351293 8.5664,8.232 L8.5664,14.6",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20.5664,
  y1: 7.4,
  x2: 24.1664,
  y2: 7.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.1664,
  y1: 12.2,
  x2: 24.1664,
  y2: 12.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 19.4,
  x2: 3.7664,
  y2: 19.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 24.2,
  x2: 6.1664,
  y2: 24.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.1664,
  y1: 5.6496,
  x2: 12.1664,
  y2: 0.2016,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1664,36.2 L12.1664,17 C12.1664,15.6745166 11.0918834,14.6 9.7664,14.6 L2.5664,14.6 C1.2409166,14.6 0.1664,15.6745166 0.1664,17 L0.1664,36.2 L14.5664,36.2",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "currency-euro-circle-copy",
  transform: "translate(16.000000, 18.000000)",
  stroke: "#425CD4"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 9,
  cy: 9,
  r: 8.59090909
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2272727,12.6818182 C7.85454545,12.6818182 6.54545455,11.3727273 6.54545455,9 C6.54545455,6.62727273 7.85454545,5.31818182 10.2272727,5.31818182",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.31818182,
  y1: 7.77272727,
  x2: 10.2272727,
  y2: 7.77272727,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.31818182,
  y1: 10.2272727,
  x2: 10.2272727,
  y2: 10.2272727,
  id: "Path"
}))));
function SvgBuildingEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "40px",
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Energiebesparing \u20AC dit jaar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingEuro);
export default __webpack_public_path__ + "static/media/Building_euro.d310a39dce58d939d69cf2ee7baa91d7.svg";
export { ForwardRef as ReactComponent };